/*
  DM — editorial article (sections/dm-article-main.liquid).
  - Drops empty legacy paragraphs and headings (nbsp-only runs the CSS cannot see).
  - FAQ: the H2 marked data-dm-faq and its H3 questions become <details> rows. The text
    is already in the HTML; this only folds it. Each answer gets a linkable id.
  - Contents: highlights the section being read, shows a "Contents" button on phones
    once the inline list has scrolled away, and opens the list in a bottom sheet.
  - Reading progress, native share / copy link, and print with every FAQ row open.
*/
(function () {
  'use strict';

  var MEDIA = 'img,iframe,video,table,hr,svg,picture,object,embed,input,button,form';

  function slug(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  function isBlank(el) {
    if (el.querySelector(MEDIA) || el.matches(MEDIA)) return false;
    return el.textContent.replace(/[\s ​]+/g, '') === '';
  }

  function cleanEmpty(prose) {
    prose.querySelectorAll('p, h2, h3, h4, h5, h6').forEach(function (el) {
      if (isBlank(el)) el.remove();
    });
  }

  // Every H3 between the FAQ H2 and the next H2, at any depth: guides nest questions in
  // <section> or <div> groups. Each question folds in place with the siblings that follow
  // it (up to the next H3) as its answer; the list around the items gets the card style.
  function buildFaq(prose) {
    var title = prose.querySelector('h2[data-dm-faq]');
    if (!title) return;
    var all = Array.prototype.slice.call(prose.querySelectorAll('h2, h3'));
    var start = all.indexOf(title);
    var questions = [];
    for (var i = start + 1; i < all.length; i++) {
      if (all[i].tagName === 'H2') break;
      if (!all[i].closest('.dm-faq__item')) questions.push(all[i]);
    }
    if (!questions.length) return;

    var used = {};
    var lists = [];
    questions.forEach(function (h3) {
      var parent = h3.parentNode;
      var item = document.createElement('details');
      item.className = 'dm-faq__item';
      var id = h3.id || 'faq-' + slug(h3.textContent);
      if (used[id]) id += '-' + Object.keys(used).length;
      used[id] = true;
      if (h3.id) h3.removeAttribute('id');
      item.id = id;
      var summary = document.createElement('summary');
      var answer = document.createElement('div');
      answer.className = 'dm-faq__answer';
      parent.insertBefore(item, h3);
      var node = h3.nextSibling;
      summary.appendChild(h3);
      while (node && !(node.nodeType === 1 && /^H[23]$/.test(node.tagName))) {
        var next = node.nextSibling;
        answer.appendChild(node);
        node = next;
      }
      item.appendChild(summary);
      item.appendChild(answer);

      var list = parent;
      if (parent.tagName === 'SECTION' && parent.children.length === 1 && parent !== prose) list = parent.parentNode;
      if (list === prose || list.contains(title)) {
        var box = document.createElement('div');
        box.className = 'dm-faq';
        item.parentNode.insertBefore(box, item);
        box.appendChild(item);
        list = box;
      }
      if (lists.indexOf(list) === -1) lists.push(list);
    });
    lists.forEach(function (list) {
      list.classList.add('dm-faq');
      // Merge single-item boxes that sit next to each other into one card.
      if (list.children.length === 1 && list.previousElementSibling && list.previousElementSibling.classList.contains('dm-faq') && list.previousElementSibling.querySelector('.dm-faq__item') && list.previousElementSibling !== list) {
        if (list.firstElementChild.classList.contains('dm-faq__item') && list.previousElementSibling.lastElementChild && list.previousElementSibling.lastElementChild.classList.contains('dm-faq__item')) {
          list.previousElementSibling.appendChild(list.firstElementChild);
          list.remove();
        }
      }
    });

    prose.querySelectorAll('.dm-faq__answer').forEach(function (a) {
      var link = document.createElement('a');
      link.className = 'dm-faq__permalink';
      link.href = '#' + a.parentNode.id;
      link.textContent = 'Link to this answer';
      link.addEventListener('click', function (event) {
        event.preventDefault();
        var url = location.href.split('#')[0] + '#' + a.parentNode.id;
        history.replaceState(null, '', '#' + a.parentNode.id);
        if (navigator.clipboard) navigator.clipboard.writeText(url).catch(function () {});
        link.textContent = 'Link copied';
        setTimeout(function () { link.textContent = 'Link to this answer'; }, 1800);
      });
      a.appendChild(link);
    });

    function openFromHash() {
      if (!location.hash) return;
      var target;
      try { target = document.querySelector(location.hash); } catch (e) { return; }
      if (!target) return;
      var details = target.closest('.dm-faq__item');
      if (details) {
        details.open = true;
        details.scrollIntoView({ block: 'start' });
      }
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  }

  function initToc(root, prose) {
    var headings = Array.prototype.slice.call(prose.querySelectorAll('h2[id]'));
    var lists = root.querySelectorAll('.dm-toc__list');
    if (!headings.length || !lists.length) return;

    var linksById = {};
    lists.forEach(function (list) {
      list.querySelectorAll('a[href^="#"]').forEach(function (a) {
        var id = decodeURIComponent(a.getAttribute('href').slice(1));
        (linksById[id] = linksById[id] || []).push(a);
      });
    });

    var current = null;
    function setCurrent(id) {
      if (id === current) return;
      if (current && linksById[current]) linksById[current].forEach(function (a) { a.removeAttribute('aria-current'); });
      current = id;
      if (id && linksById[id]) {
        linksById[id].forEach(function (a) {
          a.setAttribute('aria-current', 'true');
          var list = a.closest('.dm-toc--rail .dm-toc__list');
          if (list) {
            var top = a.offsetTop - list.offsetTop;
            if (top < list.scrollTop || top > list.scrollTop + list.clientHeight - 40) list.scrollTop = top - 40;
          }
        });
      }
    }

    function update() {
      var line = window.innerHeight * 0.3;
      var active = null;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top - line <= 0) active = headings[i].id;
        else break;
      }
      setCurrent(active);
    }

    var fab = root.querySelector('[data-dm-toc-fab]');
    var sheet = root.querySelector('[data-dm-toc-sheet]');
    var inline = root.querySelector('[data-dm-toc-inline]');
    if (fab && sheet && typeof sheet.showModal === 'function') {
      fab.hidden = false;
      fab.addEventListener('click', function () { sheet.showModal(); });
      sheet.addEventListener('click', function (event) {
        if (event.target === sheet || event.target.closest('[data-dm-toc-close]') || event.target.closest('a')) sheet.close();
      });
    } else if (fab) {
      fab = null;
    }

    function updateFab() {
      if (!fab) return;
      var anchor = inline || prose;
      var passed = anchor.getBoundingClientRect().bottom < 0;
      var notDone = prose.getBoundingClientRect().bottom > window.innerHeight * 0.6;
      fab.classList.toggle('is-visible', passed && notDone);
      fab.setAttribute('tabindex', passed && notDone ? '0' : '-1');
    }

    return function () { update(); updateFab(); };
  }

  function initProgress(root, prose) {
    var bar = root.querySelector('.dm-art__progress span');
    if (!bar) return null;
    return function () {
      var rect = prose.getBoundingClientRect();
      var total = rect.height - window.innerHeight * 0.6;
      var done = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      bar.style.setProperty('--dm-progress', done.toFixed(4));
    };
  }

  function initShare(root) {
    var box = root.querySelector('[data-dm-share]');
    if (!box) return;
    var url = box.getAttribute('data-url');
    var title = box.getAttribute('data-title');
    var native = box.querySelector('[data-dm-share-native]');
    if (native && navigator.share) {
      native.hidden = false;
      native.addEventListener('click', function () {
        navigator.share({ title: title, url: url }).catch(function () {});
      });
    }
    var copy = box.querySelector('[data-dm-share-copy]');
    if (copy) {
      var label = copy.querySelector('span');
      var original = label ? label.textContent : '';
      copy.addEventListener('click', function () {
        var done = function () {
          if (label) label.textContent = copy.getAttribute('data-done') || 'Copied';
          setTimeout(function () { if (label) label.textContent = original; }, 1800);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, done);
        else done();
      });
    }
    var print = box.querySelector('[data-dm-print]');
    if (print) print.addEventListener('click', function () { window.print(); });
  }

  function init(root) {
    if (root.__dmArt) return;
    root.__dmArt = true;
    var prose = root.querySelector('[data-dm-prose]');
    if (!prose) return;

    cleanEmpty(prose);
    buildFaq(prose);
    initShare(root);

    var tasks = [initToc(root, prose), initProgress(root, prose)].filter(Boolean);
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        tasks.forEach(function (t) { t(); });
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    var openedForPrint = [];
    window.addEventListener('beforeprint', function () {
      root.querySelectorAll('details:not([open])').forEach(function (d) { d.open = true; openedForPrint.push(d); });
    });
    window.addEventListener('afterprint', function () {
      openedForPrint.forEach(function (d) { d.open = false; });
      openedForPrint = [];
    });
  }

  function boot() {
    document.querySelectorAll('[data-dm-art]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
